
import { getProvince, getCity, getCounty } from '@/api/sys.js'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import { modifyList, isWorker, getAreaType } from '@/api/zhigongxiaojia'
import addressPicker from './address.vue'


export default {
components: {
XInput,
Group,
PopupPicker,
Confirm,
Selector,
addressPicker
},
data () {
return {
judge1: false,
judge2: false,
judge3: false,
judge4: false,
provinceid: 0,
cityid: 0,
countyid: 0,
auth: (this.$route.query.auth || '').split(','),
auth_name: [],
first_authname: [],
sourcetype: 1,
parentaccountid: '',
username: this.$route.query.accountidNAME,
page: 1,
rows: 15,
level: this.$route.query.areatype,
btnshow: false,
selectname: '',
show_auth: false,
show_confirm: false,
areatypeList: [],
addressValue: [this.$route.query.provinceid.toString(), this.$route.query.cityid.toString(), this.$route.query.countyid.toString()]
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
choose_auth () {
return this.$store.state.user.workerObj.auth
}
},
created () {
this.getAreaType()
this.push_auth()
this.judge_auth()
},
methods: {

getAreaType () {
let areatype = this.$store.state.user.workerObj.areatype
getAreaType().then(res => {
this.areatypeList = res.obj.filter(item => {
if (areatype === '4') {

return item.key === '4'
} else if (areatype === '5') {

return item.key === '5'
} else if (parseInt(item.key) >= parseInt(areatype)) {
return parseInt(item.key) >= parseInt(areatype)
}
})
})
},

create () {
this.provinceid = this.addressValue[0] || ''
this.cityid = this.addressValue[1] || ''
this.countyid = this.addressValue[2] || ''
if (this.level == '') {
this.$vux.toast.text('请选择单位层级')
return false
}
if (this.level === '1' && this.provinceid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if ((this.level === '3' || this.level === '4') && this.cityid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if (this.level === '5' && this.countyid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
}
if (this.auth == '') {
this.$vux.toast.text('请选择人员的权限配置')
return false
} else {
this.show_confirm = true
}
},
onConfirm () {
modifyList({
accountid: this.accountid,
sourcetype: parseInt(this.sourcetype),
id: parseInt(this.$route.query.id),
areatype: parseInt(this.level),
provinceid: parseInt(this.provinceid),
cityid: parseInt(this.cityid),
countyid: parseInt(this.countyid),
auth: this.auth.toString()
})
window.history.back(-1)
},

push_auth () {
var temp = (this.$route.query.authNAME || '').split(',')
this.first_authname = temp.join(' ')
},

get_auth () {
this.show_auth = true
},

confirm () {
this.show_auth = false
this.auth.sort()
var i
for (i in this.auth) {
if (this.auth[i] == 1) { this.auth_name.push('指派') }
if (this.auth[i] == 2) { this.auth_name.push('申报') }
if (this.auth[i] == 3) { this.auth_name.push('审核') }
if (this.auth[i] == 4) { this.auth_name.push('发布') }
}
var testdiv = document.getElementById('select_auth')
testdiv.innerHTML = this.auth_name.join(' ')
this.auth_name.length = 0
},

cancel () {
this.show_auth = false
},
judge_auth () {
if (this.choose_auth.indexOf('1') > -1) {
this.judge1 = true
}
if (this.choose_auth.indexOf('2') > -1) {
this.judge2 = true
}
if (this.choose_auth.indexOf('3') > -1) {
this.judge3 = true
}
if (this.choose_auth.indexOf('4') > -1 && this.$store.state.user.workerObj.areatype === '1') { // 只有省级可发布
this.judge4 = true
}
}
}
}
